import { render } from "./coin_rule.vue?vue&type=template&id=05f4b157&scoped=true"
import script from "./coin_rule.vue?vue&type=script&lang=js"
export * from "./coin_rule.vue?vue&type=script&lang=js"

import "./coin_rule.vue?vue&type=style&index=0&id=05f4b157&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f4b157"]])

export default __exports__